import { render } from "./PlatformNotices.vue?vue&type=template&id=63077cec&scoped=true"
import script from "./PlatformNotices.vue?vue&type=script&lang=js"
export * from "./PlatformNotices.vue?vue&type=script&lang=js"

import "./PlatformNotices.vue?vue&type=style&index=0&id=63077cec&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63077cec"]])

export default __exports__